import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardNotificationPreferencesRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { NotificationPreferencesPageLoadable } from './NotificationPreferencesPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<
    typeof userDashboardNotificationPreferencesRoute
  >,
) {
  await NotificationPreferencesPageLoadable.load();
}

export default function UserDashboardNotificationPreferencesHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Notification Preferences')}>
      <NotificationPreferencesPageLoadable />
    </RouteModule>
  );
}
